import { render, staticRenderFns } from "./counselingDetail.vue?vue&type=template&id=6a497897&"
import script from "./counselingDetail.vue?vue&type=script&lang=js&"
export * from "./counselingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports